import React from "react";
import { SpaceBetween } from "@amzn/awsui-components-console";
import 'src/components/selfServeWorkflows/executionView/execution-view.scss';

export const StatusIndicator = ({ taskStatus, noOfTasks }) => {
    return (
      <SpaceBetween direction="horizontal" size="xs" data-testid={`test-task-status-${taskStatus ?? ""}-legend`}>
        <span className={`task-legend ${taskStatus ?? ""}`} >
          {noOfTasks??0}
        </span>
        {taskStatus}
      </SpaceBetween>
    );
  };